import { HttpParams } from '@angular/common/http';
import { StringUtility } from '../string.utility';
import { ODataFilter } from './o-data-filter';

export class ODataRequest<TEntity> {
	public requestParams = new HttpParams();

	constructor(method: 'delete', entityUrl: string, id: string);
	constructor(method: 'put', entityUrl: string, id: string, body: any);
	constructor(method: 'patch', entityUrl: string, id: string, body: any);
	constructor(method: 'post', entityUrl: string, body: any);
	constructor(method: 'get', entityUrl: string);
	constructor(public method: 'get' | 'post' | 'delete' | 'put' | 'patch', public entityUrl: string, public postBodyOrResourceId?: any | string, public putBody?: any) {
	}

	public $top(count: number): ODataRequest<TEntity> {
		this.requestParams = this.requestParams.set('$top', count);
		return this;
	}

	public $skip(count: number): ODataRequest<TEntity> {
		this.requestParams = this.requestParams.set('$skip', count);
		return this;
	}

	public $count(): ODataRequest<TEntity> {
		this.requestParams = this.requestParams.set('$count', true);
		return this;
	}

	public $orderBy(column: string | keyof TEntity, direction: 'asc' | 'desc'): ODataRequest<TEntity> {
		this.requestParams = this.requestParams.set('$orderBy', `${column?.toString()} ${direction}`);
		return this;
	}

	public $filter<TFilteredByTarget = TEntity>(filters: ODataFilter<TFilteredByTarget>[]): ODataRequest<TEntity> {
		const filterString = filters?.map((item) => this.buildFilterString(item)).join(' ');
		this.requestParams = this.requestParams.set('$filter', filterString);
		return this;
	}

	private buildFilterString<TFilteredByTarget>(filter: ODataFilter<TFilteredByTarget>): string {
		let filterString: string;

		switch (filter?.operation) {
			case 'contains': {
				if (typeof filter?.value === 'string')
					filter.value = StringUtility.escapeODataFilterString(filter?.value);
				if (typeof filter?.column === 'object') {
					if (filter.column.parent) {
						filterString = `${filter.column.parent}/any(a:a/${filter.column?.collection?.toString()}/any(x:contains(x/${filter.column?.property}, '${filter?.value}')))`;
					} else {
						filterString = `${filter.column?.collection?.toString()}/any(x:contains(x/${filter.column?.property}, '${filter?.value}'))`;
					}
				} else {
					filterString = `contains(tolower(${filter.column?.toString()}), '${filter?.value}')`;
				}
				break;
			}
			case 'equals': {
				if (typeof filter?.column === 'object') {
					if (filter.column.parent) {
						filterString = `${filter.column.parent}/any(a:a/${filter.column?.collection?.toString()}/any(x: x/${filter.column?.property} eq '${filter?.value}'))`;
					} else {
						filterString = `${filter.column?.collection?.toString()}/any(x: x/${filter.column?.property} eq ${filter?.value})`;
					}
				} else {
					filterString = `${filter.column?.toString()} eq ${filter?.value}`;
				}
				break;
			}
			case 'not-equals': {
				if (typeof filter?.column === 'object') {
					if (filter.column.parent) {
						filterString = `${filter.column.parent}/any(a:a/${filter.column?.collection?.toString()}/any(x: x/${filter.column?.property} ne '${filter?.value}'))`;
					} else {
						filterString = `${filter.column?.collection?.toString()}/any(x: x/${filter.column?.property} ne ${filter?.value})`;
					}
				} else {
					filterString = `${filter.column?.toString()} ne ${filter?.value}`;
				}
				break;
			}
			case 'greater-than': {
				if (typeof filter?.column === 'object') {
					if (filter.column.parent) {
						filterString = `${filter.column.parent}/any(a:a/${filter.column?.collection?.toString()}/any(x: x/${filter.column?.property} gt '${filter?.value}'))`;
					} else {
						filterString = `${filter.column?.collection?.toString()}/any(x: x/${filter.column?.property} gt ${filter?.value})`;
					}
				} else {
					filterString = `${filter.column?.toString()} gt ${filter?.value}`;
				}
				break;
			}
		}

		switch (filter?.condition) {
			case 'and': {
				filterString = `and ${filterString}`;
				break;
			}
			case 'or': {
				filterString = `or ${filterString}`;
				break;
			}
			default:
				break;
		}
		if (filter?.filters?.length > 0) {
			filterString = `${filterString} ${filter.filters?.map((item) => this.buildFilterString(item)).join(' ')}`;
		}

		return filterString;
	}
}
